/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WalletConsumptionConfiguration } from '../../models/wallet-consumption-configuration';
import { WalletConsumptionConfigurationUpdate } from '../../models/wallet-consumption-configuration-update';

export interface UpdateWalletConsumptionSettings$Params {
      body: WalletConsumptionConfigurationUpdate
}

export function updateWalletConsumptionSettings(http: HttpClient, rootUrl: string, params: UpdateWalletConsumptionSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<WalletConsumptionConfiguration>> {
  const rb = new RequestBuilder(rootUrl, updateWalletConsumptionSettings.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WalletConsumptionConfiguration>;
    })
  );
}

updateWalletConsumptionSettings.PATH = '/v1/api/admin-ui/company/consumption-settings';
